import React from "react";

export function MenuItemSkeleton() {
  return (
    <div className="item-card">
      <div className="item-img skeleton-pulse" style={{ height: "180px" }} />
      <div className="item-info" style={{ padding: "12px" }}>
        <div className="skeleton-pulse" style={{ height: "18px", width: "70%", marginBottom: "8px" }} />
        <div className="skeleton-pulse" style={{ height: "16px", width: "50%", marginBottom: "12px" }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "8px" }}>
          <div className="skeleton-pulse" style={{ height: "20px", width: "40px" }} />
          <div className="skeleton-pulse" style={{ height: "24px", width: "60px", borderRadius: "4px" }} />
        </div>
      </div>
    </div>
  );
}

export function MenuGridSkeleton() {
  return (
    <div className="menu-grid">
      {Array.from({ length: 12 }).map((_, idx) => (
        <MenuItemSkeleton key={idx} />
      ))}
    </div>
  );
}

export function OrderItemSkeleton() {
  return (
    <div className="order-item" style={{ marginBottom: "16px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
        <div className="skeleton-pulse" style={{ height: "16px", width: "40%" }} />
        <div className="skeleton-pulse" style={{ height: "16px", width: "25%" }} />
      </div>
      <div className="skeleton-pulse" style={{ height: "14px", width: "60%", marginBottom: "8px" }} />
      <div className="skeleton-pulse" style={{ height: "14px", width: "50%" }} />
    </div>
  );
}

export function OrderHistorySkeleton() {
  return (
    <div style={{ padding: "0 16px" }}>
      {Array.from({ length: 4 }).map((_, idx) => (
        <OrderItemSkeleton key={idx} />
      ))}
    </div>
  );
}

export function ProfileDataSkeleton() {
  return (
    <div style={{ padding: "16px" }}>
      <div className="skeleton-pulse" style={{ height: "20px", width: "50%", marginBottom: "16px" }} />
      <div style={{ marginBottom: "16px" }}>
        <div className="skeleton-pulse" style={{ height: "16px", width: "30%", marginBottom: "8px" }} />
        <div className="skeleton-pulse" style={{ height: "40px", width: "100%", borderRadius: "8px" }} />
      </div>
      <div style={{ marginBottom: "16px" }}>
        <div className="skeleton-pulse" style={{ height: "16px", width: "30%", marginBottom: "8px" }} />
        <div className="skeleton-pulse" style={{ height: "40px", width: "100%", borderRadius: "8px" }} />
      </div>
      <div className="skeleton-pulse" style={{ height: "44px", width: "100%", borderRadius: "8px" }} />
    </div>
  );
}

export function AdminOrderSkeleton() {
  return (
    <div className="admin-order" style={{ marginBottom: "12px", padding: "12px", border: "1px solid #eee", borderRadius: "8px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
        <div className="skeleton-pulse" style={{ height: "16px", width: "35%" }} />
        <div className="skeleton-pulse" style={{ height: "16px", width: "20%" }} />
      </div>
      <div className="skeleton-pulse" style={{ height: "14px", width: "60%", marginBottom: "8px" }} />
      <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
        <div className="skeleton-pulse" style={{ height: "32px", width: "70px", borderRadius: "4px" }} />
        <div className="skeleton-pulse" style={{ height: "32px", width: "70px", borderRadius: "4px" }} />
      </div>
    </div>
  );
}

export function AdminOrderListSkeleton() {
  return (
    <div>
      {Array.from({ length: 6 }).map((_, idx) => (
        <AdminOrderSkeleton key={idx} />
      ))}
    </div>
  );
}

export function DashboardSkeleton() {
  return (
    <div style={{ padding: "1.25rem" }}>
      <div className="skeleton-pulse" style={{ height: 26, width: 140, marginBottom: "1.25rem", borderRadius: 6 }} />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} style={{ borderRadius: 12, padding: "12px 14px", border: "1px solid var(--border)" }}>
            <div className="skeleton-pulse" style={{ height: 10, width: 60, marginBottom: 8, borderRadius: 4 }} />
            <div className="skeleton-pulse" style={{ height: 24, width: 80, marginBottom: 6, borderRadius: 4 }} />
            <div className="skeleton-pulse" style={{ height: 9, width: 50, borderRadius: 4 }} />
          </div>
        ))}
      </div>
      <div style={{ background: "white", border: "1px solid var(--border)", borderRadius: 12, padding: "14px 16px", marginBottom: 16 }}>
        <div className="skeleton-pulse" style={{ height: 16, width: 120, marginBottom: 14, borderRadius: 4 }} />
        <div style={{ display: "flex", gap: 4, alignItems: "flex-end", height: 80 }}>
          {[60,40,75,50,90,35,65].map((h, i) => (
            <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
              <div className="skeleton-pulse" style={{ width: "60%", height: h + "%", borderRadius: "3px 3px 0 0" }} />
              <div className="skeleton-pulse" style={{ height: 8, width: "80%", borderRadius: 3 }} />
            </div>
          ))}
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
        {[0,1].map(col => (
          <div key={col} style={{ background: "white", border: "1px solid var(--border)", borderRadius: 12, padding: "14px" }}>
            <div className="skeleton-pulse" style={{ height: 14, width: 80, marginBottom: 12, borderRadius: 4 }} />
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: i < 3 ? "1px solid var(--border)" : "none" }}>
                <div className="skeleton-pulse" style={{ height: 12, width: "55%", borderRadius: 4 }} />
                <div className="skeleton-pulse" style={{ height: 12, width: "25%", borderRadius: 4 }} />
              </div>
            ))}
          </div>
        ))}
      </div>
      <div style={{ background: "white", border: "1px solid var(--border)", borderRadius: 12, padding: "14px" }}>
        <div className="skeleton-pulse" style={{ height: 14, width: 140, marginBottom: 14, borderRadius: 4 }} />
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} style={{ marginBottom: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <div className="skeleton-pulse" style={{ height: 11, width: "40%", borderRadius: 4 }} />
              <div className="skeleton-pulse" style={{ height: 11, width: "15%", borderRadius: 4 }} />
            </div>
            <div className="skeleton-pulse" style={{ height: 6, width: "100%", borderRadius: 3 }} />
          </div>
        ))}
      </div>
    </div>
  );
}

export function ProcessingSkeleton() {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      padding: "2rem",
      textAlign: "center",
      gap: "1.5rem"
    }}>
      {/* Animated shimmer circle */}
      <div style={{
        width: "80px",
        height: "80px",
        borderRadius: "50%",
        background: "#fff",
        border: "3px solid #f0f0f0",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="skeleton-pulse" style={{
          width: "100%",
          height: "100%",
          borderRadius: "50%"
        }} />
      </div>
      
      {/* Text loading bars */}
      <div style={{ width: "100%", maxWidth: "300px" }}>
        <div className="skeleton-pulse" style={{ height: "16px", width: "80%", margin: "0 auto 12px", borderRadius: "4px" }} />
        <div className="skeleton-pulse" style={{ height: "14px", width: "60%", margin: "0 auto 12px", borderRadius: "4px" }} />
        <div className="skeleton-pulse" style={{ height: "13px", width: "70%", margin: "0 auto", borderRadius: "4px" }} />
      </div>
    </div>
  );
}
